import { getCredentialChangeStatus } from '~/api/action-logs';

export default {
  methods: {
    /**
     * Check user change credential history
     * @command - [apicall] checkCredentialChangeHistory [/apicall]
     */
    async checkCredentialChangeHistory() {
      const responses = {
        userIsNotLoggedIn: '[apiresponse] userIsNotLoggedIn [/apiresponse]',
        userCredentialWasChanged7DaysAgo: '[apiresponse] userCredentialWasChanged7DaysAgo [/apiresponse]',
        userCredentialWasChangedMoreThan7DaysAgo:
          '[apiresponse] userCredentialWasChangedMoreThan7DaysAgo [/apiresponse]',
      };
      try {
        const today = new Date();
        const aWeekAgo = new Date();
        aWeekAgo.setDate(aWeekAgo.getDate() - 7);
        const startDate = `${aWeekAgo.getFullYear()}-${aWeekAgo.getMonth() + 1}-${aWeekAgo.getDate()}`;
        const endDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        await getCredentialChangeStatus(this.$axios, { startDate, endDate });
        this.$zopim.sendChatMsg(responses.userCredentialWasChanged7DaysAgo);
        return;
      } catch (error) {
        if (error?.response?.data?.meta?.http_status === 403) {
          this.$zopim.sendChatMsg(responses.userIsNotLoggedIn);
          return;
        }
        this.$zopim.sendChatMsg(responses.userCredentialWasChangedMoreThan7DaysAgo);
      }
    },
  },
};
